import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "select"]

  async updateSquadron(event) {
    event.preventDefault()
    const form = this.formTarget
    const select = this.selectTarget
    const squadronId = select.value

    console.log('Updating squadron...', {
      squadronId: squadronId,
      formAction: form.action
    })

    try {
      const response = await fetch(form.action, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content,
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          squadron_id: squadronId
        })
      })

      console.log('Response status:', response.status)
      
      if (!response.ok) throw new Error('Update failed')
      
      const data = await response.json()
      console.log('Update successful:', data)
      
      // Optional: Show success message
      this.showNotification('Squadron updated successfully', 'success')
      
    } catch (error) {
      console.error('Update failed:', error)
      this.showNotification('Failed to update squadron', 'error')
      // Optionally revert the select to its previous value
      select.value = select.dataset.currentSquadron || ''
    }
  }

  showNotification(message, type) {
    const notification = document.createElement('div')
    notification.className = `notification ${type}`
    notification.textContent = message
    document.body.appendChild(notification)
    setTimeout(() => notification.remove(), 3000)
  }
}